module.exports = __webpack_public_path__ + "static/media/parking.8af8f8d3.png";